import React from 'react';
import { Link } from 'react-router-dom';
import { services } from '../data/services';

const Services = () => {
  return (
    <>
      {/* Page Header */}
      <section className="page-header">
        <div className="container">
          <h1>Our Services</h1>
          <p>
            From light-touch consultations to full-service event styling, 
            we have a package for every host and every budget. Perfect for 
            the girlies and gays who don't want to email 9 florists.
          </p>
        </div>
      </section>

      {/* Services Overview */}
      <section className="bg-white pt-2xl pb-2xl">
        <div className="container">
          <div className="services-grid mb-2xl">
            {services.map((service) => (
              <div key={service.id} className="service-card">
                <div className="service-icon">{service.icon}</div>
                <h3>{service.name}</h3>
                <p>{service.tagline}</p>
                <p className="service-price">Starting at {service.startingPrice}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Service Details */}
      {services.map((service, index) => (
        <section 
          key={service.id} 
          id={service.id}
          className={index % 2 === 0 ? 'bg-cream' : 'bg-white'}
          style={{ padding: '4rem 0' }}
        >
          <div className="container">
            <div className="service-detail">
              <div className={`service-detail-content ${index % 2 === 1 ? 'reverse' : ''}`}>
                <div className="service-detail-image">
                  <img src={service.image} alt={service.name} />
                </div>
                <div className="service-detail-info">
                  <span style={{ 
                    fontSize: '2rem', 
                    marginBottom: '0.5rem', 
                    display: 'block' 
                  }}>
                    {service.icon}
                  </span>
                  <h3>{service.name}</h3>
                  <p style={{ fontStyle: 'italic', color: '#c4a574', marginBottom: '1rem' }}>
                    {service.tagline}
                  </p>
                  <p>{service.fullDesc}</p>
                  <p style={{ marginTop: '1rem' }}>
                    <strong>Ideal For:</strong> {service.idealFor}
                  </p>

                  <div className="service-includes">
                    <h5>What's Included</h5>
                    <ul>
                      {service.includes.map((item, idx) => (
                        <li key={idx}>{item}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            {/* Pricing Table */}
            <div className="pricing-table">
              <table>
                <thead>
                  <tr>
                    <th>Guest Count</th>
                    <th>Price</th>
                  </tr>
                </thead>
                <tbody>
                  {service.pricing.map((tier, idx) => (
                    <tr key={idx}>
                      <td>{tier.guests}</td>
                      <td style={{ fontWeight: '600', color: '#c4a574' }}>{tier.price}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Add-ons */}
            {service.addons && service.addons.length > 0 && (
              <div style={{ marginTop: '2rem' }}>
                <h4 style={{ marginBottom: '1rem' }}>Optional Add-ons</h4>
                <div style={{ 
                  display: 'grid', 
                  gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', 
                  gap: '1rem' 
                }}>
                  {service.addons.map((addon, idx) => (
                    <div 
                      key={idx} 
                      style={{ 
                        padding: '1rem', 
                        background: '#faf8f5', 
                        borderRadius: '8px',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center'
                      }}
                    >
                      <span>{addon.name}</span>
                      <span style={{ fontWeight: '600', color: '#c4a574' }}>{addon.price}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}

            <div className="text-center mt-xl">
              <Link to="/contact" className="btn btn-gold btn-lg">
                Book {service.name}
              </Link>
            </div>
          </div>
        </section>
      ))}

      {/* Host Box Section */}
      <section className="bg-blush pt-2xl pb-2xl">
        <div className="container">
          <div className="section-header">
            <h2>The Host Box</h2>
            <div className="section-divider"></div>
            <p>
              Ready-to-style kits for beautifully themed gatherings — 
              curated by Midnight Aurelia Events, designed to be set up at home.
            </p>
          </div>

          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', 
            gap: '1.5rem',
            maxWidth: '800px',
            margin: '0 auto 2rem'
          }}>
            <div style={{ 
              padding: '1.5rem', 
              background: '#fff', 
              borderRadius: '12px',
              textAlign: 'center'
            }}>
              <h4>Standard</h4>
              <p style={{ fontSize: '0.875rem', color: '#666', marginBottom: '0.5rem' }}>
                4–6 guests
              </p>
              <p style={{ fontSize: '1.5rem', fontWeight: '700', color: '#c4a574' }}>$95</p>
            </div>
            <div style={{ 
              padding: '1.5rem', 
              background: '#fff', 
              borderRadius: '12px',
              textAlign: 'center',
              border: '2px solid #c4a574'
            }}>
              <h4>Medium</h4>
              <p style={{ fontSize: '0.875rem', color: '#666', marginBottom: '0.5rem' }}>
                8–12 guests
              </p>
              <p style={{ fontSize: '1.5rem', fontWeight: '700', color: '#c4a574' }}>$125</p>
            </div>
            <div style={{ 
              padding: '1.5rem', 
              background: '#fff', 
              borderRadius: '12px',
              textAlign: 'center'
            }}>
              <h4>Deluxe</h4>
              <p style={{ fontSize: '0.875rem', color: '#666', marginBottom: '0.5rem' }}>
                15–20 guests
              </p>
              <p style={{ fontSize: '1.5rem', fontWeight: '700', color: '#c4a574' }}>$150–175</p>
            </div>
          </div>

          <div className="text-center">
            <Link to="/party-boxes" className="btn btn-primary btn-lg">
              Shop All Party Boxes
            </Link>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <h2>Not Sure Which Service Is Right for You?</h2>
          <p>
            Book a free 15-minute discovery call and we'll help you find the 
            perfect package for your celebration style and budget.
          </p>
          <div className="cta-buttons">
            <Link to="/contact" className="btn btn-primary btn-lg">
              Book a Free Call
            </Link>
            <Link to="/party-boxes" className="btn btn-secondary btn-lg">
              Browse Party Boxes
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default Services;
